import React from "react";
import { css } from "@emotion/css";
import { aboutEventImage1, aboutEventImage2 } from "../assets/images";

const AboutEvent = () => {
    const aboutEventStyles = {
        section: css`
            padding: 4rem 0;
            background-color: #fefbf3;
        `,
        container: css`
            max-width: 80rem;
            margin: 0 auto;
            padding: 0 1rem;
            @media (min-width: 640px) {
                padding: 0 1.5rem;
            }
            @media (min-width: 1024px) {
                padding: 0 2rem;
            }
        `,
        headerBanner: css`
            background-color: #ff6b6b;
            color: white;
            padding: 1.5rem 2rem;
            border-radius: 0 1rem;
            margin-bottom: 2rem;
            font-size: 1.5rem;
            font-weight: 700;
            display: inline-block;
            max-width: 100%;
            @media (min-width: 768px) {
                font-size: 1.75rem;
            }
        `,
        contentGrid: css`
            display: grid;
            grid-template-columns: 1fr;
            gap: 2rem;
            @media (min-width: 1024px) {
                grid-template-columns: 1fr 1fr;
                gap: 3rem;
            }
        `,
        leftColumn: css`
            display: flex;
            flex-direction: column;
            gap: 1rem;
        `,
        imageCollage: css`
            background-color: white;
            border-radius: 0 1rem;
            height: 100%;
            padding: 1rem;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
            background-image: linear-gradient(to top, #dfe9f3 0%, white 100%);
        `,
        imagesRow: css`
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
            align-items: center;
            height: 100%;
        `,
        image: css`
            width: 100%;
            height: 250px;
            object-fit: cover;
            border-radius: 0.75rem;
        `,
        rightColumn: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
        textContent: css`
            color: #374151;
            line-height: 1.7;
        `,
        paragraph: css`
            margin-bottom: 1.5rem;
            font-size: 1.1rem;
            &:last-child {
                margin-bottom: 0;
            }
        `,
        description: css`
            color: #4b5563;
            margin-bottom: 1.5rem;
            font-size: 0.875rem;
            line-height: 1.5;

            @media (min-width: 640px) {
                margin-bottom: 1.75rem;
                font-size: 0.9375rem;
            }

            @media (min-width: 1024px) {
                margin-bottom: 2rem;
                font-size: 1rem;
            }

            @media (max-width: 768px) {
                text-align: justify;
            }
        `,
    };

    return (
        <section
            className={aboutEventStyles.section}
            id="about-event"
            aria-labelledby="about-event-title"
        >
            <div className={aboutEventStyles.container}>
                <h2 className={aboutEventStyles.headerBanner}>
                    What is the Event about
                </h2>

                <div className={aboutEventStyles.contentGrid}>
                    <div className={aboutEventStyles.leftColumn}>
                        <div className={aboutEventStyles.imageCollage}>
                            <div className={aboutEventStyles.imagesRow}>
                                <img
                                    src={aboutEventImage1}
                                    alt="Group of young adults celebrating outdoors"
                                    className={aboutEventStyles.image}
                                />
                                <img
                                    src={aboutEventImage2}
                                    alt="Group of young adults lying on grass"
                                    className={aboutEventStyles.image}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={aboutEventStyles.rightColumn}>
                        <div className={aboutEventStyles.textContent}>
                            <p className={aboutEventStyles.paragraph}>
                                The Event is organized to understand and
                                experience the concept of 'Oneness'.
                            </p>
                            <p className={aboutEventStyles.paragraph}>
                                Celebration of Oneness with Shreekalp'. It
                                involves singing & dancing of oneness, which
                                helps us to forget ourselves from the present
                                moment. We forget that we are 'All-different'
                                and experience that we are 'All-one'. Also, we
                                understand the real meaning of friendship and
                                become true friends of the greatest virtue
                                called Humanity. This platform gives an
                                opportunity to perform & manifest various forms
                                of art, skills & talents too
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutEvent;
